import request from '@/services/base-service';
import { InternalAxiosRequestConfig } from 'axios';
import {
  CoCauHistoryStrategyMapRequest,
  PerspectiveMap,
  RequestMucTieuThanhPhan,
  UpdateStrategyMapRequest,
} from '@/types/performance/buoc4congty';
import { RequestHeader } from '@/types/base';
import { MucTieuThanhPhanView } from '@/types/performance/buoc4thanhphan';
import type { ApiResponse } from '@/types/base';

const baseURl = '/v1/performance';

export const StrategyMapCompanyAPI = {
  getStrategyMap: (requestHeader: RequestHeader) =>
    request.post<ApiResponse<PerspectiveMap[]>>(`${baseURl}/getstrategymap`, requestHeader, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  getStrategyMapCoCauHistory: (payload: CoCauHistoryStrategyMapRequest) =>
    request.post<ApiResponse<PerspectiveMap[]>>(`${baseURl}/getstrategymap-cocau-history`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  updateStrategyMap: (requestDTO: UpdateStrategyMapRequest) =>
    request.post(`${baseURl}/updatestrategymap`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),

  getmuctieuthanhphan: (requestHeader: RequestMucTieuThanhPhan) =>
    request.post<MucTieuThanhPhanView>(`${baseURl}/getmuctieuthanhphan`, requestHeader, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  checkBanDoMucTieuThanhPhan: (requestHeader: RequestHeader) =>
    request.post<ApiResponse<boolean>>(`${baseURl}/checkbandomuctieuthanhphan`, requestHeader, {
      authorization: true,
    } as InternalAxiosRequestConfig),
};
